import React, { useEffect, useRef } from "react";
import "./MicWaveAnimation.css";

const MicWaveAnimation = () => {
  const canvasRef = useRef(null);
  const animationRef = useRef(null);
  const historyRef = useRef([]);
  const maxHistoryLength = 150; // Adjust for desired width coverage
  const prevHeightsRef = useRef([]);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;

    const centerY = canvas.height / 2;

    let audioCtx, analyser, source;
    let dataArray;
    let frameCount = 0;
    const frameSkip = 4; // update only every 3rd frame to slow down

    const startMic = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        audioCtx = new (window.AudioContext || window.webkitAudioContext)();
        analyser = audioCtx.createAnalyser();
        analyser.fftSize = 64;

        dataArray = new Uint8Array(analyser.frequencyBinCount);
        source = audioCtx.createMediaStreamSource(stream);
        source.connect(analyser);

        const draw = () => {
          animationRef.current = requestAnimationFrame(draw);
          analyser.getByteFrequencyData(dataArray);

          // Reduce frame rate to slow scrolling
          if (++frameCount % frameSkip !== 0) return;

          const avg =
            dataArray.reduce((sum, val) => sum + val, 0) / dataArray.length;
          const normalized = (avg / 255) * canvas.height * 1; // Taller bars

          historyRef.current.unshift(normalized);
          if (historyRef.current.length > maxHistoryLength) {
            historyRef.current.pop();
          }

          // Clear canvas
          ctx.clearRect(0, 0, canvas.width, canvas.height);

          const barWidth = 3;
          const gap = 2;
          const totalBarSpace = barWidth + gap;

          for (let i = 0; i < historyRef.current.length; i++) {
            const x = canvas.width - i * totalBarSpace;
            const targetHeight = historyRef.current[i];
          
            // Get previous height or fall back
            const prevHeight = prevHeightsRef.current[i] || 0;
          
            // Smoothly animate toward new height (lerp)
            const animatedHeight = prevHeight + (targetHeight - prevHeight) * 0.2;
          
            // Save animated height for next frame
            prevHeightsRef.current[i] = animatedHeight;
          
            ctx.fillStyle = "#6366F1";
            ctx.fillRect(x, centerY, barWidth, -animatedHeight);
            ctx.fillRect(x, centerY, barWidth, animatedHeight);
          }
        };

        draw();
      } catch (err) {
        console.error("Mic access error:", err);
      }
    };

    startMic();

    return () => {
      cancelAnimationFrame(animationRef.current);
      if (audioCtx) audioCtx.close();
    };
  }, []);

  return (
    <div className="mic-wave-wrapper">
      <canvas ref={canvasRef} className="mic-wave-canvas" />
    </div>
  );
};

export default MicWaveAnimation;
